// Конфигурация аналитики и cookie-согласия.
// Ключ куки и формат значения согласованы с лендингом (backdoor-tech-app,
// lib/consent): выбор хранится в куке на `.backdoor.tech` и общий для сайта
// и приложения — кто уже решил на backdoor.tech, баннер здесь не увидит.

export const GA_MEASUREMENT_ID = "G-BCNS36Q7T5";

// GA включена только на проде: стрим создан под app.backdoor.tech.
// На localhost/preview ни тега, ни баннера — чтобы не слать dev-хиты.
export const ANALYTICS_HOST = "app.backdoor.tech";

export const CONSENT_COOKIE_KEY = "bd-consent";
export const CONSENT_VERSION = 1;

export type ConsentState = {
  analytics: boolean;
  ts: number;
  v: number;
};

export function analyticsEnabled(): boolean {
  return typeof window !== "undefined" && window.location.hostname === ANALYTICS_HOST;
}
